import { render, staticRenderFns } from "./InvestorOnboardingReceiptPayments.vue?vue&type=template&id=c3453bb4&scoped=true&"
import script from "./InvestorOnboardingReceiptPayments.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingReceiptPayments.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingReceiptPayments.vue?vue&type=style&index=0&id=c3453bb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3453bb4",
  null
  
)

export default component.exports